import { useTranslation } from 'react-i18next';
import { motion } from 'framer-motion';
import { useAuth } from 'src/contexts/AuthContext';

const AuthRedirectOverlay = () => {
   const [t] = useTranslation();
   const { isAuthRedirecting } = useAuth();

   if (!isAuthRedirecting) {
      return null;
   }

   return (
      <motion.div
         className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/40 backdrop-blur-[2px]"
         initial={{ opacity: 0 }}
         animate={{ opacity: 1 }}
         transition={{ duration: 0.2 }}
      >
         <motion.div
            className="relative w-[92%] max-w-[420px] overflow-hidden rounded-2xl border border-white/30 bg-white px-5 py-4 shadow-2xl"
            initial={{ scale: 0.96, y: 8 }}
            animate={{ scale: 1, y: 0 }}
            transition={{ duration: 0.25, ease: 'easeOut' }}
         >
            <motion.div
               className="pointer-events-none absolute inset-0 opacity-40"
               animate={{
                  background: [
                     'radial-gradient(circle at 20% 30%, rgba(99,102,241,0.18), transparent 45%)',
                     'radial-gradient(circle at 80% 20%, rgba(16,185,129,0.18), transparent 45%)',
                     'radial-gradient(circle at 20% 30%, rgba(99,102,241,0.18), transparent 45%)',
                  ],
               }}
               transition={{ duration: 3.2, repeat: Infinity, ease: 'easeInOut' }}
            />

            <div className="relative flex items-center gap-3">
               <div className="flex h-10 w-10 items-center justify-center rounded-full bg-primary/10">
                  <span className="inline-block h-5 w-5 rounded-full border-2 border-primary border-r-transparent animate-spin" />
               </div>
               <div className="flex-1">
                  <p className="text-sm md:text-base font-semibold text-black">{t('common.authRedirecting')}</p>
                  <div className="mt-1 flex items-center gap-1">
                     <motion.span
                        className="h-1.5 w-1.5 rounded-full bg-primary"
                        animate={{ opacity: [0.35, 1, 0.35], y: [0, -1, 0] }}
                        transition={{ duration: 0.9, repeat: Infinity, delay: 0 }}
                     />
                     <motion.span
                        className="h-1.5 w-1.5 rounded-full bg-primary"
                        animate={{ opacity: [0.35, 1, 0.35], y: [0, -1, 0] }}
                        transition={{ duration: 0.9, repeat: Infinity, delay: 0.15 }}
                     />
                     <motion.span
                        className="h-1.5 w-1.5 rounded-full bg-primary"
                        animate={{ opacity: [0.35, 1, 0.35], y: [0, -1, 0] }}
                        transition={{ duration: 0.9, repeat: Infinity, delay: 0.3 }}
                     />
                  </div>
               </div>
            </div>

            <div className="relative mt-3 h-1.5 overflow-hidden rounded-full bg-slate-200">
               <motion.div
                  className="h-full rounded-full bg-primary"
                  initial={{ x: '-100%' }}
                  animate={{ x: ['-100%', '100%'] }}
                  transition={{ duration: 1.25, repeat: Infinity, ease: 'easeInOut' }}
               />
            </div>
         </motion.div>
      </motion.div>
   );
};

export default AuthRedirectOverlay;
